import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';
import { StripeService } from 'src/app/services/stripe.service';

@Component({
	selector: 'app-welcome-subscription-type',
	templateUrl: './subscription-type.component.html',
	styleUrls: ['./subscription-type.component.css']
})
export class WelcomeSubscriptionTypeComponent implements OnInit {
	loading = true;
	stopNavigation = false;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private clientService: ClientService,
		private contextService: ContextService,
		private stripeService: StripeService
	) { }

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			if (params['stopNavigation']) {
				this.stopNavigation = params['stopNavigation'];
			}
		});

		if (this.contextService.clientDetailProcore.dropboxSignAPIKeyExists) {
			let accountType = '';
			if (this.contextService.clientDetailProcore.subscriptionType == 'connector') {
				accountType = 'connector';
			} else if (this.contextService.clientDetailProcore.subscriptionType == 'shared') {
				accountType = 'shared';
			}
			this.router.navigate(['/welcome/authenticate'], { queryParams: { accountType: accountType, } });
		} else {
			this.retrieveQuotes();
		}
	}

	retrieveQuotes() {
		if (this.contextService.stripeCustomerId) {
			this.stripeService.getStripeQuotes(this.contextService.stripeCustomerId)
				.subscribe((quotes) => {
					console.log(quotes);
					if (quotes.length > 0) {
						this.formatQuoteDates(quotes);
					} else {
						this.loading = false;
					}
				});
		} else {
			// This will get the customer id
			this.clientService.createClientCustomerId(this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.companyName)
				.subscribe((customerId) => {
					this.contextService.stripeCustomerId = customerId;

					this.stripeService.getStripeQuotes(customerId)
						.subscribe((quotes) => {
							console.log(quotes);
							if (quotes.length > 0) {
								this.formatQuoteDates(quotes);
							} else {
								this.loading = false;
							}
						});
				});
		}
	}

	formatQuoteDates(quotes) {
		let containsSubscription = false;

		for (let quote of quotes) {
			let d = new Date(0);
			let utc = quote.expiresAt;
			d.setUTCSeconds(utc);

			quote.expiresAt = d;

			console.log(quote.subscriptionId);
			if (quote.status == 'accepted') {
				containsSubscription = true;
			}
		}

		this.contextService.quotes = quotes;

		if (!this.stopNavigation) {
			if (containsSubscription) {
				this.router.navigate(['/welcome/purchase/configure']);
			} else {
				this.router.navigate(['/welcome/purchase/quotes']);
			}
		} else {
			this.loading = false;
		}
	}

	selectTrial() {
		this.router.navigate(['/welcome/trial']);
	}

	selectPurchase() {
		this.router.navigate(['/welcome/purchase']);
	}
}